import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setCookiePreferences } from '../store/slices/authSlice';

export const useCookieConsent = () => {
  const dispatch = useDispatch();
  const { cookiePreferences } = useSelector(state => state.auth);

  const checkCookieConsent = () => {
    return cookiePreferences !== null;
  };

  const hasAnalyticsConsent = () => {
    return cookiePreferences?.analytics === true;
  };

  const hasMarketingConsent = () => {
    return cookiePreferences?.marketing === true;
  };

  const hasPreferencesConsent = () => {
    return cookiePreferences?.preferences === true;
  };

  return {
    hasConsent: checkCookieConsent(),
    hasAnalyticsConsent: hasAnalyticsConsent(),
    hasMarketingConsent: hasMarketingConsent(),
    hasPreferencesConsent: hasPreferencesConsent(),
    cookiePreferences
  };
}; 